// extracted by mini-css-extract-plugin
export default {"editorSearch":"ProjectsTable_editorSearch__omJFN"};